import React, { useState } from 'react';

import scss from './ReviewSlider.module.scss';
import { VwpReview } from '../types';
import SingleReview from './SingleReview';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Slider from '@components/Slider';

type ReviewSliderProps = {
    reviews: VwpReview[]
}

const ReviewSlider = ({ reviews }: ReviewSliderProps) => {
    const [slideIndex, setSlideIndex] = useState(0);
    
    return (
        <>
            <div className={scss.fadingBorder}></div>
            <div className={scss.container}>
                <button
                    className={scss.swipeButton}
                    disabled={slideIndex <= 0}
                    onClick={() => setSlideIndex( x => x < 1 ? 0 : x - 1 )}
                >
                    <Icon icon={faChevronLeft} />
                </button>
                <Slider className={scss.slider} idx={slideIndex} handleIndex={setSlideIndex}>
                    {reviews.map((review, index) => <SingleReview key={index} review={review} />)}
                </Slider>
                <button
                    className={scss.swipeButton}
                    disabled={slideIndex >= reviews.length - 1}
                    onClick={() => setSlideIndex(x => x >= (reviews.length - 1) ? (reviews.length - 1) : x + 1)}
                >
                    <Icon icon={faChevronRight} />
                </button>
            </div>
            <div className={scss.fadingBorder}></div>
        </>
        
    );
};

export default ReviewSlider;